<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" @count="(count) => is_first = count < 1" />
    </template>
    <Upload v-show="upload" ref="upload_csv" />
    <Detail v-if="detail" @refresh="refresh" :is_first="is_first" @count="(count) => is_first = count < 1" />
  </div>
</template>

<script>
import List from './site.List.i18n';
import Upload from './Site.Upload.csv';
import Detail from './site.Detail.i18n';

export default {
  components: { List, Detail, Upload },
  data: () => ({ base: false, list: false, detail: false, is_first : false, upload : false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    // 뷰 전환
    select({ id, tag }) {
      if(id === 'csv' && !tag) { this.base = this.list = this.detail = false; this.upload = true }
      else if(!id) { this.base = this.list = !(this.upload = this.detail = false); }
      else { this.detail = !(this.upload = this.list = false); }
    }
  },
  created: function() { console.log('site.vue', 'created'); },
  destroyed: function() { console.log('site.vue', 'destroyed'); },
  mounted: function() { console.log('site.vue', 'mounted'); this.select(this.$route.params); },
  watch: { '$route' (to, from) { console.log('site.vue', 'route changed', to.param); this.select(to.params); } },
}
</script>
